import { render, staticRenderFns } from "./task-count.vue?vue&type=template&id=42ba1ff7&scoped=true&"
import script from "./task-count.vue?vue&type=script&lang=js&"
export * from "./task-count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ba1ff7",
  null
  
)

export default component.exports